


















import { Component, Watch, Prop } from 'vue-property-decorator'
import ViewBase from '@/util/ViewBase'
import { ListType } from '@/util/types'
import { courseItem, resourceItem } from '@/api/res'
import { parse } from 'qs'
import TestPersonInfo from './testPersonInfo.vue'
const echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/bar')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')

@Component({
  components: { TestPersonInfo }
})
export default class TestClassInfo extends ViewBase {
  @Prop({ default: null }) studentNumber!: any
  @Prop({ default: null }) levelStatistical!: any
  @Prop({ default: 0 }) time!: number

  lang: any = {}

  levelArr: any = []

  colorArr: any = ['#58ACEE', '#FAD6EE', '#FE9947', '#4EDEC0']

  echartsArr: any = []

  get i18n() {
    const value = this.$t('login')
    return value as any
  }

  get isEnLang() {
    return this.$i18n.locale == 'en'
  }

  setEcharts() {
    const myCharts = echarts.init(this.$refs.myCharts)
    const _this = this
    // const myCharts = document.getElementById('myCharts')
    const option = {
      title: {
        text: this.lang.testStudentRate,
        // subtext: '纯属虚构',
        left: 'center'
      },
      tooltip: {
        trigger: 'item',
        // formatter: '{a} <br/>{b} : {c} ({d}%)'
        formatter: '{c}人'
      },
      series: [
        {
          name: _this.lang.studentRate,
          type: 'pie',
          radius: '55%',
          center: ['50%', '60%'],
          data: _this.echartsArr,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            normal: {
              // \n\n可让文字居于牵引线上方，很关键
              //  {b}  代表显示的内容标题
              // {c}代表数据
              formatter: ' {b}：{d}% \n\n'
            }
          }
        }
      ]
    }

    // 绘制图表
    myCharts.setOption(option)
  }

  created() {
    this.lang = this.i18n.vClients
  }

  @Watch('levelStatistical')
  watchLevelStatistical(info: any) {
    if (info && info.length > 0) {
      const echartsArr: any = []
      info.forEach((item: any, index: any) => {
        const ex: any = {}
        ex.name = item.level_name
        ex.value = item.num
        ex.itemStyle = { normal: { color: this.colorArr[index] } }
        echartsArr.push(ex)
      })
      this.echartsArr = echartsArr
    } else {
      this.echartsArr = []
    }
    this.setEcharts()
  }
}
